import React, { useEffect } from 'react';
import { Box, Button, Divider, Skeleton, Stack, Typography } from '@mui/material';
import { AddCircle, Refresh } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTypedDispatch, useTypedSelector } from '../../hooks';
import { getDevices, devicesSelector } from '../../store/reducers';
import { UserList } from '../../components/Pages/users';
import { DeviceList } from '../../components/Pages/devices/DeviceList';

const Devices: React.FC = function () {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useTypedDispatch();
  const { isLoading, devices, error } = useTypedSelector(devicesSelector);

  useEffect(() => {
    if (!isLoading) dispatch(getDevices());
  }, []);

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error, { variant: 'error' });
    }
  }, [error]);

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '15px',
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: '15px',
        }}
      >
        <Typography variant="h6" align="left">
          Devices
        </Typography>

        <Box>
          <Button
            variant={'outlined'}
            style={{ marginRight: '10px' }}
            color={'primary'}
            onClick={() => dispatch(getDevices())}
          >
            <Refresh />
          </Button>
          <Button variant="outlined" startIcon={<AddCircle />} onClick={() => navigate(`/devices/new`)}>
            Create Device
          </Button>
        </Box>
      </Box>

      <Divider />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          flexGrow: 1,
          padding: '15px',
        }}
      >
        {isLoading ? (
          <Stack spacing={1}>
            <Skeleton animation={'pulse'} variant={'text'} width={'80vw'} height={'10vh'}>
              <DeviceList devices={[]} />
            </Skeleton>
            <Skeleton animation={'pulse'} variant={'rectangular'} width={'80vw'} height={'65vh'}>
              <DeviceList devices={[]} />
            </Skeleton>
          </Stack>
        ) : (
          <DeviceList devices={devices} />
        )}
      </Box>
    </Box>
  );
};

export default Devices;
